import img1 from '../../assets/img/img-1.png'
import img2 from '../../assets/img/img-2.png'
import img3 from '../../assets/img/img-3.png'
import img5 from '../../assets/img/img-5.png'
import img7 from '../../assets/img/img-7.png'
import React, { useState } from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';


function FatosImportantes({ dadosAnimal }) {

    const [valorSliderComissao, setValorSliderComissao] = useState(dadosAnimal.card.projetado);

    function handleSliderComissaoChange(newValue) {
        setValorSliderComissao(newValue);
    }


    function calculaDiferencaMesPassado() {
        try {
            const percentualDiferencaMesPassado = dadosAnimal.percentualDiferencaMesAnterior;

            if (percentualDiferencaMesPassado < 0) {
                return {
                    msg: `Até o momento, você vendeu ${percentualDiferencaMesPassado.toFixed(2).replace('.', ',')}%  que no mês passado.`,
                    img: img3
                }
            }

            if (percentualDiferencaMesPassado > 0) {
                return {
                    msg: `Até o momento, você vendeu + ${percentualDiferencaMesPassado.toFixed(2).replace('.', ',')}% que no mês passado.`,
                    img: img5
                }
            }
            
            return {
                msg: `Até o momento você vendeu a mesma quantidade que no mês passado ou não constam informações do mês anterior.`,
                img: img5
            }
        } catch(error) {
            console.error('Erro: '+ error.message)
        }
    }

    function calcularFaltaParaNivelA() {
        try {
            const faltaParaNivelA = dadosAnimal.fatosImportantes.faltaParaNivelA;
        
            if (faltaParaNivelA === 0) {
                return 'Parabéns, você já alcançou o nível A!';
            }

            let faltaParaNivelAFormatado;

            if (dadosAnimal.formatacao.valores === 'quantidade') {
                faltaParaNivelAFormatado = parseInt(faltaParaNivelA);
            } 
            
            if (dadosAnimal.formatacao.valores === 'percentual') {
                faltaParaNivelAFormatado = `${faltaParaNivelA.toLocaleString('pt-BR')}%`;
            } 
            
            if (dadosAnimal.formatacao.valores === 'moeda') {
                faltaParaNivelAFormatado = faltaParaNivelA.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
            }

            return `Você precisa de ${faltaParaNivelAFormatado} para chegar ao nível A.`;
        } catch(error) {
            console.error('Erro: '+ error.message)
        }
    }

    function formatarComissaoIdeal() {
        try {
            const comissaoIdeal = dadosAnimal.fatosImportantes.comissaoIdeal;
            const faltaParaComissaoIdeal = dadosAnimal.fatosImportantes.faltaParaComissaoIdeal;

            const comissaoIdealFormatado = comissaoIdeal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
            const faltaParaComissaoIdealFormatado = faltaParaComissaoIdeal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

            return `Você precisa de ${faltaParaComissaoIdealFormatado} a mais de vendas para chegar a ${comissaoIdealFormatado} de valor de comissão em média.`;
        } catch(error) {
            console.error('Erro: '+ error.message)
        }
    }

    function calcularComissaoSlider() {
        try {
            const comissao = (valorSliderComissao * dadosAnimal.dados[0].somaprojecaocomissao) / dadosAnimal.card.projetado;
            return comissao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        } catch(error) {
            console.error('Erro: '+ error.message)
        }
    }

    return (
        <section className="bg-white py-8 pb-12">
            <div className="container">
                <div className="font-poppins">
                    <h2 className="font-semibold text-[26px] text-gray-c5 text-center">Fatos importantes</h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 my-8">
                    <div className="grid grid-cols-5 gap-4 items-center border border-gray-c20 bg-gray-c4 p-2 text-left">
                        <img src={img1} alt={img1} className="object-contain max-w-full w-16 justify-self-center" />
                        <div className="col-span-4">
                            <p className="pr-0 lg:pr-48 font-normal text-lg text-gray-c21">{calcularFaltaParaNivelA()}</p>
                        </div>
                    </div>
                    <div className="grid grid-cols-5 gap-4 items-center border border-gray-c20 bg-gray-c4 p-2 text-left">
                        <img src={calculaDiferencaMesPassado().img} alt="emoji" className="object-contain max-w-full w-16 justify-self-center" />
                        <div className="col-span-4">
                            <p className="pr-0 lg:pr-48 font-normal text-lg text-gray-c21">{calculaDiferencaMesPassado().msg}</p>
                        </div>
                    </div>
                </div>
                {(dadosAnimal.dados.length > 0) &&
                    (dadosAnimal.dados[0].somaprojecaocomissao && dadosAnimal.dados[0].somaprojecaocomissao > 0) && 
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 my-8">
                        <div className="relative inline-block">
                            <div className="absolute top-0 text-red-c1 left-1">*</div>
                            <div className="grid grid-cols-5 gap-4 items-center border border-gray-c20 bg-gray-c4 p-2 text-left">
                                <img src={img2} alt={img2} className="object-contain max-w-full w-16 justify-self-center" />
                                <div className="col-span-4">
                                    <p className="font-normal text-lg text-gray-c21">{formatarComissaoIdeal()}</p>
                                </div>
                            </div>
                        </div>

                        <div className="relative inline-block">
                            <div className="absolute top-0 text-red-c1 left-1">*</div>
                            <div className="grid grid-cols-5 gap-4 items-center border border-gray-c20 bg-gray-c4 p-2 text-left">
                                <img src={img7} alt={img7} className="object-contain max-w-full w-16 justify-self-center" />
                                <div className="col-span-4">

                                    <div className="flex items-center">
                                        <Slider
                                            min={dadosAnimal.card.projetado}
                                            max={dadosAnimal.fatosImportantes.valorMaximoSliderComissao}
                                            step={50}
                                            value={valorSliderComissao}
                                            onChange={handleSliderComissaoChange}
                                            style={{ marginRight: '12px' }}
                                        />
                                        <span className="text-gray-c21 ml-2 text-lg">{valorSliderComissao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                                    </div>
                                    <p className="text-gray-c21 mt-2 text-lg">{`Comissão Simulada: ${calcularComissaoSlider()}`}</p>
                                </div>
                            </div>
                        </div>

                        <p className="text-red-c1 mt-2 text-sm">* Simulação de valores em projeção de vendas em média, depende da linha a ser vendida para o valor final.</p>
                    </div>

                }

            </div>
        </section>
    );
}

export default FatosImportantes